<template>
  <Card class="mb-4">
    <template #header>
      <h2 class="mb-0">Versicherungsnehmer</h2>
    </template>
    <div>
      <div>
        <b-row>
          <b-col md="6">
            <h4>Datum Sicherheitstraining</h4>
            <base-input prepend-icon="fas fa-calendar"
              v-model="offer.softfair_hat_ansicherheitstraining_teilgenommen_datum" type="date"
              name="Hat an Sicherheitstraining teilgenommen Datum" rules="required"
              placeholder="DD.MM.YYYY"></base-input>
          </b-col>

          <b-col md="6">
            <h4>Tarifgruppe</h4>
            <BaseSelect v-model="offer.softfair_tarifgruppe" :options="tarifgruppeOptions" />
          </b-col>
        </b-row>

        <b-row>

          <b-col lg="6">
            <h4 @click="toggleRealEstate()">Wohneigentum</h4>
          </b-col>

        </b-row>

        <b-row>

          <b-col lg="6">
            <BaseCheckbox v-model="show_real_estate" :inline="true">Hat Wohneigentum</BaseCheckbox>
          </b-col>

        </b-row>


        <div v-if="show_real_estate">

          <b-row>

            <b-col lg="6">
              <h4>Typ</h4>
              <BaseSelect v-model="offer.softfair_wohneigentum_typ" :options="wohneigentumOptions" label="" />
            </b-col>

            <b-col lg="6">
              <BaseInput v-model="offer.softfair_wohneigentum_versicherung_id"
                :value="offer.softfair_wohneigentum_versicherung_id || ''" type="number" label="Versicherung ID" />
            </b-col>

          </b-row>

          <b-row>

            <b-col lg="6">
              <BaseCheckbox v-model="offer.softfair_wohneigentum_ist_vermietet"
                :checked="offer.softfair_wohneigentum_ist_vermietet" :inline="true">Ist vermietet</BaseCheckbox>
            </b-col>

          </b-row>


          <b-row>

            <b-col lg="6">
              <BaseInput v-model="offer.softfair_wohneigentum_anzahl_versicherte_gefahren"
                :value="offer.softfair_wohneigentum_anzahl_versicherte_gefahren || ''" type="number"
                label="Anzahl versicherte Gefahren" />
            </b-col>

          </b-row>


        </div>


      </div>
      
    </div>

    <b-row>
      <b-col lg="6">
        <h4 @click="toggleOptional()">Optional</h4>
      </b-col>
      <b-col lg="6" class="text-right">
        <i v-if="show_optional" class="fa fa-chevron-down" @click="toggleOptional()"></i>
        <i v-else class="fa fa-chevron-left" @click="toggleOptional()"></i>
      </b-col>
    </b-row>


    <div v-if="show_optional">



      <b-row>
        <b-col md="6">
          <BaseInput v-model="offer.softfair_branche" :value="offer.softfair_branche || ''" type="number"
          label="Branche" />
        </b-col>

        <b-col md="6">
          <BaseInput v-model="offer.softfair_spezieller_arbeitgeber" :value="offer.softfair_spezieller_arbeitgeber || ''"
          type="number" label="Spezieller Arbeitgeber" />
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <BaseInput v-model="offer.softfair_beruf" :value="offer.softfair_beruf || ''" type="number" label="Beruf" />
        </b-col>

        <b-col md="6">
          <BaseInput v-model="offer.softfair_kinder" label="Kinder" />
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <BaseInput v-model="offer.softfair_mitgliedschaften" :value="offer.softfair_mitgliedschaften || ''"
          label="Mitgliedschaften" />
        </b-col>
        <b-col md="6">
          <BaseInput v-model="offer.softfair_firma" :value="offer.softfair_firma || ''" label="Firma" />
        </b-col>

      </b-row>


      <b-row>
        <b-col md="6">
          <BaseInput v-model="offer.softfair_stellung" :value="offer.softfair_stellung || ''" type="number"
              label="Stellung" />
        </b-col>
        <b-col md="6">
          <BaseInput v-model="offer.softfair_arbeitgeber_branche" :value="offer.softfair_arbeitgeber_branche || ''"
          type="number" label="Arbeitgeber Branche" />
        </b-col>

      </b-row>


      <b-row>

<b-col md="6">
  <BaseSelect v-model="offer.softfair_hat_jahreskarte_oeffentlicher_personenverkehr_zusatz"
    :options="jahreskarteOptions" label="Hat Jahreskarte ÖPNV" />
</b-col>
</b-row>

        

      <b-row>
        <b-col md="6">
          <BaseCheckbox v-model="offer.softfair_ist_vorsteuer_abzugsberechtigt"
            :checked="offer.softfair_ist_vorsteuer_abzugsberechtigt" :inline="true">Ist Vorsteuer abzugsberechtigt
          </BaseCheckbox>
          <BaseCheckbox v-model="offer.softfair_hat_am_begleiteten_fahren_teilgenommen" :inline="true">Hat am
            begleiteten
            Fahren teilgenommen</BaseCheckbox>
          <BaseCheckbox v-model="offer.softfair_hat_wohn_sitz_seit_mindestens_5_jahren"
            :checked="offer.softfair_hat_wohn_sitz_seit_mindestens_5_jahren" :inline="true">Hat Wohnsitz seit mindestens
            5
            Jahren</BaseCheckbox>
          <BaseCheckbox v-model="offer.softfair_hat_punkte_in_flensburg"
            :checked="offer.softfair_hat_punkte_in_flensburg" :inline="true">Hat Punkte in Flensburg</BaseCheckbox>
          <BaseCheckbox v-model="offer.softfair_hat_fuehrerschein_in_eu_erworben"
            :checked="offer.softfair_hat_fuehrerschein_in_eu_erworben" :inline="true">Hat Führerschein in EU erworben
          </BaseCheckbox>
          <BaseCheckbox v-model="offer.softfair_ist_mitarbeiter_autohersteller"
            :checked="offer.softfair_ist_mitarbeiter_autohersteller" :inline="true">Ist Mitarbeiter Autohersteller
          </BaseCheckbox>
        </b-col>
      </b-row>

      <b-row>

        <b-col md="6">
          <BaseSelect v-model="offer.softfair_familienstand" :options="familienstandOptions" label="Familienstand" />
        </b-col>
      </b-row>

    </div>
  </Card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import BaseInput from '@/components/Inputs/BaseInput.vue';
import BaseCheckbox from '@/components/Inputs/BaseCheckbox.vue';
import BaseSelect from '@/components/Inputs/BaseSelect.vue';
import CscDateInput from '@/components/Inputs/CscDateInput.vue';
import Card from '@/components/Cards/Card.vue';

export default {
  name: "softfair-versicherungsnehmer",
  components: {
    BaseInput,
    BaseCheckbox,
    BaseSelect,
    CscDateInput,
    Card,
  },
  data() {
    return {
      loading: false,
      show_optional: false,
      show_real_estate: false,
      versicherungsnehmerDetails: {
        privat: {
          stellung: 0,
          hatJahreskarteOeffentlicherPersonenverkehrZusatz: "BahnComfort",
          istMitarbeiterAutohersteller: true,
          tarifgruppe: "Normal",
          hatAnSicherheitstrainingTeilgenommenDatum: null,
          hatFuehrerscheinInEuErworben: true,
          arbeitgeberBranche: 0,
          wohneigentum: {
            typ: "EinZweifamilienhaus",
            versicherungId: 49,
            istVermietet: false,
            anzahlVersicherteGefahren: 1
          },
          hatPunkteInFlensburg: false,
          branche: 9900,
          kinder: null,
          fuehrerscheindatum: "{{var_fuehrerschein}}",
          speziellerArbeitgeber: 0,
          hatWohnsitzSeitMindestens5Jahren: true,
          mitgliedschaften: null,
          istVorsteuerAbzugsberechtigt: true,
          hatAmBegleitetenFahrenTeilgenommen: true,
          beruf: 1,
          familienstand: "LedigAlleinstehend"
        },
        firma: null
      },
      jahreskarteOptions: [ "BahnComfort", "BahnNormal", "Sonstige" ],
      tarifgruppeOptions: ['Normal', 'Premium', 'Basic'],
      wohneigentumOptions: ['EinZweifamilienhaus', 'Eigentumswohnung', 'Reihenhaus', 'KeineAngaben'],
      familienstandOptions: ['LedigAlleinstehend', 'Verheiratet', 'Geschieden', 'Verwitwet', 'GetrenntLebend']
    };
  },
  methods: {
    toggleOptional() {
      this.show_optional = !this.show_optional;
    },
    setDefaults() {
    },
    financial(x) {
      if (isNaN(Number.parseFloat(x).toFixed(2))) {
        return 0;
      }
      return Number.parseFloat(x).toFixed(2);
    },
  },
  computed: {
    ...mapGetters({
      currentAccount: "currentAccount",
    }),
    ...mapState({
      account: state => state.account,
      offer: (state) => state.softfairOffer,
    }),
  },
  mounted() {
  },
};
</script>
<style></style>